import React from 'react';
import '../../styles/analytics-theme.css';

const StatsCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  variant = 'default',
  onClick,
  style,
}) => {
  const className = [
    'ab-stat-card',
    variant === 'primary' ? 'primary' : '',
    onClick ? 'clickable' : '',
  ].filter(Boolean).join(' ');

  return (
    <div
      className={className}
      onClick={onClick}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      } : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      style={style}
    >
      <div className="ab-stat-card-inner">
        <div>
          <p className="ab-stat-label">{title}</p>
          <p className="ab-stat-value">{value}</p>
          {subtitle && <p className="ab-stat-subtitle">{subtitle}</p>}
        </div>
        {Icon && (
          <div className="ab-stat-icon">
            <Icon size={20} strokeWidth={2} />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;
